import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import log from 'lib/log'
const component = universal(() => import('./CircleDesktopPage'))
import { clearGroup, loadGroup, loadAccessRequests } from 'state/actions/groups'
import { clearPosts } from 'state/actions/posts'

import prepareTertiaryContent from './tertiary_content'

class AsyncGroupPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      location: { type: place, payload: { group } },
      session: { value: profile } = {},
      group: { value: { group: cachedGroup = {} } = {} }
    } = getState()

    try {
      dispatch(clearPosts())
      if (cachedGroup._id !== group) {
        dispatch(clearGroup())
      }
      let result = await loadGroup({ _id: group })(dispatch, getState, opts)
      let { membership } = result
      if (membership && membership.role === 'ADMIN') {
        try {
          let access_requests = await loadAccessRequests({
            group,
            filter: '_PENDING'
          })(dispatch, getState, opts)
        } catch (err) {
          log.error(err)
        }
      }
      await prepareTertiaryContent(
        result,
        profile,
        place,
        dispatch,
        getState,
        opts
      )
    } catch (e) {
      log.error(e)
    }
  }
}

export default new AsyncGroupPage()
